/*
 * US states + territories — canonical list used by all <select> dropdowns
 * in the wizard. `value` is the 2-char USPS code (what we persist);
 * `name` is the full display label (what users read). F3.
 *
 * MassMutual's published worksite coverage spans all 50 states + DC; PR
 * is excluded by default per the handoff spec. Flip INCLUDE_PR to expand.
 */
export const INCLUDE_PR = false;

export const US_STATES_RAW = [
    ["AL", "Alabama"],
    ["AK", "Alaska"],
    ["AZ", "Arizona"],
    ["AR", "Arkansas"],
    ["CA", "California"],
    ["CO", "Colorado"],
    ["CT", "Connecticut"],
    ["DE", "Delaware"],
    ["DC", "District of Columbia"],
    ["FL", "Florida"],
    ["GA", "Georgia"],
    ["HI", "Hawaii"],
    ["ID", "Idaho"],
    ["IL", "Illinois"],
    ["IN", "Indiana"],
    ["IA", "Iowa"],
    ["KS", "Kansas"],
    ["KY", "Kentucky"],
    ["LA", "Louisiana"],
    ["ME", "Maine"],
    ["MD", "Maryland"],
    ["MA", "Massachusetts"],
    ["MI", "Michigan"],
    ["MN", "Minnesota"],
    ["MS", "Mississippi"],
    ["MO", "Missouri"],
    ["MT", "Montana"],
    ["NE", "Nebraska"],
    ["NV", "Nevada"],
    ["NH", "New Hampshire"],
    ["NJ", "New Jersey"],
    ["NM", "New Mexico"],
    ["NY", "New York"],
    ["NC", "North Carolina"],
    ["ND", "North Dakota"],
    ["OH", "Ohio"],
    ["OK", "Oklahoma"],
    ["OR", "Oregon"],
    ["PA", "Pennsylvania"],
    ["RI", "Rhode Island"],
    ["SC", "South Carolina"],
    ["SD", "South Dakota"],
    ["TN", "Tennessee"],
    ["TX", "Texas"],
    ["UT", "Utah"],
    ["VT", "Vermont"],
    ["VA", "Virginia"],
    ["WA", "Washington"],
    ["WV", "West Virginia"],
    ["WI", "Wisconsin"],
    ["WY", "Wyoming"],
    ["PR", "Puerto Rico"],
];

// Alphabetized by full name (already is, but sort for safety + territory toggle).
export const US_STATES = US_STATES_RAW
    .filter(([code]) => INCLUDE_PR || code !== "PR")
    .map(([value, name]) => ({ value, name }))
    .sort((a, b) => a.name.localeCompare(b.name));

export const US_STATE_NAME = Object.fromEntries(
    US_STATES_RAW.map(([code, name]) => [code, name]),
);
